import React from 'react';
import AnimatedSection from './AnimatedSection';

interface SectionHeadingProps {
  title: React.ReactNode;
  description?: string;
  eyebrow?: string;
  dark?: boolean;
  emphasis?: boolean;
}

export default function SectionHeading({ title, description, eyebrow, dark = true, emphasis = false }: SectionHeadingProps) {
  const echoText = typeof title === 'string' ? title : undefined;
  return (
    <AnimatedSection className="section-heading mb-12">
      {eyebrow && <span className="section-heading__eyebrow">{eyebrow}</span>}
      <h2 className={`text-3xl sm:text-4xl font-bold mt-1 ${dark ? 'text-white' : 'text-black'} ${emphasis ? 'layered-title' : ''}`}>
        {emphasis && echoText && <span className="layered-title__echo" aria-hidden="true">{echoText}</span>}
        <span className={emphasis ? 'layered-title__text' : undefined}>{title}</span>
      </h2>
      {description && <p className={`mt-4 max-w-2xl mx-auto ${dark ? 'text-gray-400' : 'text-gray-600'}`}>{description}</p>}
      <span className="section-heading__line" aria-hidden="true" />
    </AnimatedSection>
  );
}
